<template>
<!--  -->
<div ref='editor' @mousemove="mousemove" @mouseup="componentCancelSelect" @mouseleave="componentCancelSelect">
	<!-- <ImportViews ref='ImportViews'></ImportViews> -->
	<!--  :hideBtn="true" :hideBtnText="$t('cmd85',['取消'])" -->
	<Window :title="$t('fill3rd143',[$t('word1909'),'编辑系统布局'])" @Closed="onClosed" ref="Window">
		<template slot="headButton" >
			<button class="bdSub boxR hover-bg-highLight" @click="$refs.Window.hide()" type="button" onclick="statistic('A29','A2916')">{{$t('cmd85',['取消'])}}</button>
			<button v-if="list&&list.length" class="functionBtn boxR" v-debounce:click="preview" type="button" onclick="statistic('A29','A2914')">{{$t('word1341',['预览'])}}</button>
			<button v-if="list&&list.length" class="functionBtn boxR" v-debounce:click="save" type="button" onclick="statistic('A29','A2915')">{{$t('cmd84',['保存'])}}</button>
		</template>
		<div class="plant-layout-edit-drag-item dpN">
			<img class="w2x h3x bgSolarComp boxR-light" :src="stage.loc.baseRouter+'static/image/solarPanel.svg'">
		</div>
		<div class="bgDesktop pd1x">
			<div class="tableSys vaT_E">
				<div class="panel w26x bgPanel">
					<div class="title">{{$t('word1926',['组件设备列表'])}}
						<div class="tool pl1x_E hover-f-main_E">
							<button class="sizeS" :title="$t('cmd79',['导入'])" onclick="statistic('A29','A2902')"  v-show='list&&list.length !== 0' v-debounce:click='importFile'>
								<Icon name="import" class="w1x h1x" />
							</button>
							<button class="sizeS" :title="$t('cmd139',['导出'])" onclick="statistic('A29','A2903')" v-show='list&&list.length !== 0' v-debounce:click='exportFile'>
								<Icon name="export" class="w1x h1x" />
							</button>
						</div>
					</div>
					<InputText class="ml1x mr1x mb2x" :clearBtn="true" :searchBtn="true" v-model="searchSn" :fn="searchList" @AfterClear="afterclear" :placeholder="$t('fill3rd125',[$t('word648'),'请输入组件SN'])"></InputText>
					<div class="posR" fillHeight="lastHeight,-space">
						<NoData v-show="list&&list.length==0"></NoData>
						<div class="pl1x pr1x compScroll" fillHeight="lastHeight,-space" scroll>
							<Loading ref="LoadingList"></Loading>
							<ul class="noSelect mb1x_E">
								<li v-for="li in listV" class="tableSys vaT_E">
									<div class="w4x" @mousedown="e=>{componentSelect({e,component:li})}">
										<img class="w100pct h6x bgSolarComp boxR-light peN" :src="stage.loc.baseRouter+'static/image/solarPanel.svg'">
									</div>
									<div class="pl1x">
										<div class="fs12x lh1">{{getTypeText(li.type,'deviceType')+li.sn}}</div>
										<div class="mt05x cSub lh13">{{$t('word1643',['坐标'])+`(${li.x>0?li.x:'--'},${li.y>0?li.y:'--'})`}}</div>
										<div class="mt05x cSub lh13">{{getLanguageStr('manage188','组串/编号')+`(${li.gi>0?li.gi:'--'},${li.gn>0?li.gn:'--'})`}}</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="w1x"></div>
				<div class="panel bgPanel displayBox tra" :style="{left:this.previewStyle.left,top:this.previewStyle.top,right:this.previewStyle.right,bottom:this.previewStyle.bottom,width:this.previewStyle.width,height:this.previewStyle.height,position:this.previewStyle.position}">
					<!-- 
					<div class="pt1x pb1x">
						<div class="classGroup cField">
							<button type="button"></button>
						</div>
					</div>
					 -->
					<Loading ref="Loading"></Loading>
					<!--<PanelDisplay :id="id" :systemId="systemId" :mode="'edit'" :curComponent="curComponent" @DragSuccess="dragSuccess" @Loading="onLayoutLoading" @Update="onLayoutUpdate" ref="PanelDisplay"></PanelDisplay>-->
				</div>
			</div>
		</div>
	</Window>
</div>
</template>
<script>
import * as lib from '@/util/lib';

import Window from '@/components/common/ui/WindowForNew.vue';
import InputText from '@/components/common/ui/InputText.vue';
import Loading from '@/components/common/ui/Loading';
import NoData from '@/components/common/ui/NoResult';

import PanelDisplay from '@/view/maintain/light/plant/part/layout/PanelDisplay.vue';
import ImportViews from '@/view/maintain/light/plant/part/layout/ImportView';
import {exportLayout} from '@/api/maintain/layout/index'

import {apiPostLayout} from '@/api/maintain/layout/index';

export default{
	name:"LayoutEdit",
	components:{Window,InputText,Loading,NoData,ImportViews},//PanelDisplay,
	props:{
		id:{//请求id
			type:Number,
			default:null
		},
		systemId:{//请求id
			type:Number,
			default:null
		},
		// addClass:{//激活的索引项
		// 	type:[String,Object],
		// 	default:""
		// },
	},
	data(){
		return{
			stage,
			dynamic:null,//记录dynamic实体
			planelDisplay:null,//组件实体
			basicInfo:{},
			searchSn: '',
			exportData:{
				systemId:'',
				field:{
					componentSN:getLanguageStr("word647",'组件'),
					coordinateX :getLanguageStr("word1643+X","坐标X"),
					coordinateY:getLanguageStr('word1643+Y ','坐标Y '),
					groupString :getLanguageStr('word1115','组串'),
					number :getLanguageStr('word1116','编号')
				}
			},
			layoutBg:null,
			list:null,
			listV:[],
			dateSys:{
				type:"day",//时间档位
				format:{//使用格式
					day:"YYYY/MM/DD",
					month:"YYYY/MM",
					year:"YYYY",
					all:"YYYY"
				},
				date:lib.timeFormat(new Date(),"utc","%Y/%m/%d",{offset:this.timeZoneCode})
			},
			curComponent:null,
			orginPosition:{},
			isPreview:false,
			previewStyle:{
				// display:'table-cell',
				left:'auto',
				top:'auto',
				right:'auto',
				bottom:'auto',
				position:'inherit'
			},
			previewDefLocation:{
				left:0,
				right:0
			}
		}
	},
	watch:{},
	methods:{
		getTypeText:lib.getTypeText,
		getLanguageStr,
		searchList () {
      statistic('A29','A2910')
			this.listV = this.list.filter(item => {
				if((lib.getTypeText(item.type,'deviceType')+item.sn.toLowerCase()).indexOf(this.searchSn.toLowerCase())!==-1){
					return item
				}
			})
		},
		afterclear () {
			this.listV = Object.assign([],this.list)
		},
		importFile(){
			this.$dynamic(this.$refs.editor,ImportViews,{},{Update:[this.onEdit.bind(this)]}).then(({
				instance,childInstance
			})=>{
				childInstance.show(this.basicInfo,this.systemId,this.exportData, instance)
			})
			// this.$refs.ImportViews.show()
		},
		onEdit(data){//编辑完成后
			this.panelDisplay.load({data});
			// this.$emit('Update',data)
		},
		exportFile(){ 
			this.exportData.systemId = this.systemId
			exportLayout(this.basicInfo.id,this.exportData).then(res => {
				let blob = new Blob([res], { type: 'application/ms-excel' })
				let downloadElement = document.createElement('a')
				let href = window.URL.createObjectURL(blob) //创建下载的链接
				downloadElement.href = href
				// console.log(this.basicInfo)
				// let title =' `电站${}系统布局信息`'
				let title = i18n.t('fill3rd177', [this.basicInfo.name, '电站{0}系统布局信息'])
				downloadElement.download = `${title}.xlsx`; //下载后文件名 fill3rd177
				document.body.appendChild(downloadElement)
				downloadElement.click() //点击下载
				document.body.removeChild(downloadElement) //下载完成移除元素
				window.URL.revokeObjectURL(href) //释放掉blob对象
			}, error => {
				// console.log(error)
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		dateChange:function(action){//切换日期
		},
		getDateData:function(){//获取对应日期的数据
		},
		disabledDate(time){//禁用时间规则
			let day = new Date().getTime();
			return day < time ;
		},
		onLayoutLoading:function(){
			this.$refs.LoadingList.show();
		},
		onLayoutUpdate:function(data){
			this.$refs.LoadingList.hide();
			// this.list=_.cloneDeep(data);
			this.list=data.layoutItem;
			this.layoutBg=_.cloneDeep(data.layoutBg);
			// this.listV = Object.assign([],this.list)
			this.searchList();
		},
		show:function(argvs,basicInfo,dynamic){
      statistic('A29','A2901')
			this.dynamic=dynamic;
			this.basicInfo=basicInfo
			lib.fillHeight();
			this.$refs.LoadingList.show();
			this.$refs.Loading.show();
			this.$refs.Window.show({end:()=>{
				lib.fillHeight();
				this.panelDisplay.show();
				// this.$refs.PanelDisplay.resize();
				lib.setScroll($(this.$el).find("[scroll]"));
				this.$refs.LoadingList.hide();
				this.$refs.Loading.hide();
			}});
		},
		preview(){
			this.panelDisplay.isPreview = true
			this.previewStyle.position = 'fixed'
			$('.compScroll').css({'pointer-events':'none'})
			this.previewDefLocation.left = this.previewStyle.left = $('.displayBox')[0].getBoundingClientRect().left+'px'//'335px'
			this.previewDefLocation.top = this.previewStyle.top = $('.displayBox')[0].getBoundingClientRect().top+'px'//'70px'
			this.previewStyle.bottom = '1em'
			this.previewStyle.right = '1em'
			setTimeout(() => {
				this.previewStyle = {
					left:'0',
					top:'0',
					right:'0',
					bottom:'0',
					position:'fixed'
				}
			}, 0)
			setTimeout(() => {
				this.panelDisplay.resize();
			}, 800)
		},
		CancelPreview(){
			this.panelDisplay.isPreview = false
			$('.compScroll').css({'pointer-events':'auto'})
			this.previewStyle.left = this.previewDefLocation.left 
			this.previewStyle.top = this.previewDefLocation.top
			this.previewStyle.bottom = '1em'
			this.previewStyle.right = '1em'
			setTimeout(() => {
				this.previewStyle = {
					left:'',
					top:'',
					right:'',
					bottom:'',
					position:''
				}
				this.panelDisplay.resize();
			}, 800)
		},
		save:function(){
			if(this.list.length){
				apiPostLayout(
					this.id,this.systemId,
					{layoutItem:this.list,layoutBg:this.layoutBg}
				).then(res=>{
					this.$emit("Update");
					this.$refs.Window.hide();
					this.panelDisplay.clear();
					// if (this.dynamic){
					// }
				});
			}
		},
		onClosed:function(){//销毁
			this.panelDisplay.clear();
			if (this.dynamic){
				this.dynamic.destroyUi()
			}
		},
		componentSelect(target){
			let component = target.component;
			if(target.fromPanel){//从面版中拖动的panel
				this.listV.map(item=>{
					if(item.id == component.id && item.sn == component.sn) component=item;
				})
			}
			this.curComponent = component;
			// console.log(component)
			this.panelDisplay.setCurComponent(component);
			let e = target.e;
			this.orginPosition = {x:e.pageX,y:e.pageY}
			$('.plant-layout-edit-drag-item').css('display','block')
		},
		dragSuccess(point){
			// console.log(point)
			// this.listV = this.listV.map(item=>{
			// 	if(item.id == point.component.id) {
			// 		item.x = point.xn;
			// 		item.y = point.yn
			// 	}
			// 	return item;
			// })
			// console.log(this.listV)
			$('.plant-layout-edit-drag-item').css('display','none');
		},
		componentCancelSelect(){
			this.curComponent = null;
			this.panelDisplay.setCurComponent(null);
			$('.plant-layout-edit-drag-item').animate({
				left:this.orginPosition.x,
				top:this.orginPosition.y
			},500,()=>{$('.plant-layout-edit-drag-item').css('display','none');});
		},
		mousemove(e){
			$('.plant-layout-edit-drag-item').css('left',e.pageX + 5)
			$('.plant-layout-edit-drag-item').css('top',e.pageY + 5)
		}
	},
	computed:{
	},
	created(){
	},
	destroyed(){
	},
	mounted(){
		lib.fillHeight();

		this.$nextTick(()=>{
			lib.setScroll($(this.$el).find("[scroll]"));
		});
		//动态创建组件展示，否则因其内部会调用本编辑组件而导致不兼容
		this.$dynamic($(this.$el).find(".displayBox")[0],PanelDisplay,
				{id:this.id,systemId:this.systemId,mode:"edit"},
				{
					Update:[this.onLayoutUpdate.bind(this)],
					Loading:[this.onLayoutLoading.bind(this)],
					DragSuccess:[this.dragSuccess.bind(this)],
					ComponentSelect:[this.componentSelect.bind(this)],
					CancelPreview:[this.CancelPreview.bind(this)]
				},{}
			).then(({instance, childInstance}) => {
				this.panelDisplay=childInstance;
			}
		);
	}
}
</script>
<style lang="scss" scoped>
.plant-layout-edit-drag-item{
	position: fixed;
	z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/layout/Edit.vue